import "./env";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import "./styles/index.css";
import "./styles/rechart.css";
import App from "./app/App";

ReactDOM.render(<App />, document.getElementById("root"));
